<div class="table-header-setting drag-container" cdkDropList (cdkDropListDropped)="drop($event)">
  <div class="table-header-setting-item drag-item" *ngFor="let item of tableHeader; let i = index" cdkDrag cdkDragHandle>
    <!-- 排序图标 -->
    <div class="sort-icon drag-handle">
      <i nz-icon nzType="menu"></i>
    </div>
    <div class="check">
      <label nz-checkbox [(ngModel)]="item.isShow"></label>
    </div>
    <div class="table-header-setting-item-label">{{ item.label }}</div>
    <div class="table-header-setting-item-width"><nz-input-number [nzMin]="10" [nzMax]="200" [nzStep]="10" [(ngModel)]="item.width"></nz-input-number>&nbsp;&nbsp;px</div>
  </div>
</div>
